import { render, staticRenderFns } from "./StudentVoiceSample.vue?vue&type=template&id=7328719d&scoped=true&"
import script from "./StudentVoiceSample.vue?vue&type=script&lang=js&"
export * from "./StudentVoiceSample.vue?vue&type=script&lang=js&"
import style0 from "./StudentVoiceSample.vue?vue&type=style&index=0&id=7328719d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7328719d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VProgressCircular})
